export const LOGO_FAMILY_VARIANT_PRESENTATION = Object.freeze({
  primary: Object.freeze({
    title: "Основной логотип",
    application: "Сайт, обложки курсов, упаковка, презентации, соцсети, титульные экраны, печатные и редакционные материалы.",
  }),
  compact: Object.freeze({
    title: "Компактная версия",
    application: "Аватары, небольшие форматы, узкие поверхности, мобильные интерфейсы, подписи на изображениях и небольшая упаковка.",
  }),
  mark: Object.freeze({
    title: "Монограмма / фирменный знак",
    application: "Пломбы, наклейки, сургуч, тиснение, детали упаковки, паттерны, водяные знаки и фирменные штампы.",
  }),
});

export function logoFamilyVariantPresentation(variant) {
  return LOGO_FAMILY_VARIANT_PRESENTATION[variant?.role] || Object.freeze({
    title: "Дополнительная версия",
    application: normalizeLogoFamilyExplanation(variant?.application),
  });
}

export function normalizeLogoFamilyExplanation(value = "") {
  return String(value)
    .replace(/наиболее профессиональна typographic-first архитектура/gi, "лучше всего подходит система, в которой главным остаётся название бренда, набранное выразительной типографикой")
    .replace(/по принципу typographic-first/gi, "так, чтобы главным оставалось название бренда, набранное выразительной типографикой")
    .replace(/\btypographic-first\b/gi, "с выразительной типографикой в основе")
    .replace(/\bmonogram\s*\/\s*seal\s*mark\b/gi, "монограмма / фирменный знак")
    .replace(/\bseal\s*mark\b/gi, "фирменный знак")
    .replace(/\bcompact[-\s]lockup\b/gi, "компактная версия")
    .replace(/основной\s+wordmark\b/gi, "основной логотип")
    .replace(/\bwordmark\b/gi, "основной логотип")
    .replace(/\bmark\b/gi, "фирменный знак")
    .replace(/знак-печать/gi, "фирменный знак");
}
